import React, { useEffect, useState } from "react";
import "./video_semblanza.css";
import { useTranslation } from "react-i18next";

const Video_semblanza = () => {
  const [lang, setLang] = useState(localStorage.getItem("language") || "es");
  const [langText, setLangText] = useState(
    lang === "es" ? "English" : "Español"
  );
  const [t, i18n] = useTranslation("librVerd");

  return (
    <div class="NLV_video_semblanza">
      <div class="NLV_semblanza_vd">
        <video class="NLV_semblanza_vd_source" controls>
          <source
            src="https://www.ricardosalinas.com/Content/assets/img/libros/lanzamiento/IDEAS-lanzamiento-720p.mp4"
            type="video/mp4"
          />
        </video>
      </div>
      <div class="NLV_semblanza_txt">
        <p>
          {t("viedo_semblanza.parrafo1")}
          <span class="NLV_txt_negro">{t("viedo_semblanza.span1")}</span>
          {" " + t("viedo_semblanza.parrafo2")}
          <br />
          <br />
          {t("viedo_semblanza.parrafo3")}{" "}
          <span class="NLV_txt_negro">{t("viedo_semblanza.span2")}</span>
          {" " + t("viedo_semblanza.parrafo4")}
          <span class="NLV_txt_negro">{t("viedo_semblanza.span3")}</span>
          {" " + t("viedo_semblanza.parrafo5")}
          <span class="NLV_txt_negro">{t("viedo_semblanza.span4")}</span>
          {" " + t("viedo_semblanza.parrafo6")}
          <span class="NLV_txt_negro">{t("viedo_semblanza.span5")}</span>
          {" " + t("viedo_semblanza.parrafo7")}
        </p>
      </div>
    </div>
  );
};

export default Video_semblanza;
